import * as R from 'ramda'
import { RouteRecord } from 'vue-router'
import { getProductCodeByUrl } from '@/utils/common'
console.log(getProductCodeByUrl())
const { domain } = getProductCodeByUrl()
const MenuCollapseKey = `${domain.toUpperCase()}_MENU_COLLAPSE__`
const activeMenuNameKey = `${domain.toUpperCase()}_ACTIVE_MENU_NAME__`

export default () => {
  const router = useRouter()
  const menuCollapse = useStorage(MenuCollapseKey, false, window.localStorage)
  const activeMenuName = useStorage(
    activeMenuNameKey,
    'Draft',
    window.localStorage,
  )
  const activeLabel = computed(() =>
    R.pathOr(
      '',
      ['meta', 'title'],
      R.find(
        R.propEq(activeMenuName.value, 'name'),
        router.getRoutes() as any[],
      ) as RouteRecord,
    ),
  )

  return {
    menuCollapse,
    activeMenuName,
    activeLabel,
  }
}
